<script>
  import { emitter } from '@/main.js';
  import { augmentHistoryReplaceState } from '@/lib/vue-helpers.js';
  export default {
    name: 'PriceFilterSlider',
    props: {
      priceFilterMin: {
        type: Number,
        required: true
      },
      priceFilterMax: {
        type: Number,
        required: true
      },
      priceFilter: {
        type: Number,
        required: true
      },
      sliderColor: {
        type: String,
        required: true
      },
      borderColor: {
        type: String,
        required: true
      },
      borderRadius: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        sliderValue: this.priceFilter,
        currentMin: this.priceFilterMin,
        currentMax: this.priceFilterMax,
        minGap: 0,
        timeout: null,
        countryCode: window.countryCode,
        isInitialized: false,
        sliderTrackElement: null, // Cache DOM element
        textInputTimeout: null
      };
    },
    methods: {
      userInputText(event) {
        if (event?.target?.id === 'minInput') {
          this.currentMin = event.target.value;
        } else if (event?.target?.id === 'maxInput') {
          this.currentMax = event.target.value;
        }
        if (this.textInputTimeout) {
          clearTimeout(this.textInputTimeout);
        }
        this.textInputTimeout = setTimeout(() => {
          this.fillColor();
          this.updateNarrow('Price_from_to', this.currentMin + '-' + this.currentMax);
          this.textInputTimeout = null;
        }, 1000);
      },
      getUrlParam(param) {
        const url = new URL(window.location.href);
        return url.searchParams.get(param);
      },
      getCurrentFilters() {
        let filters = this.getUrlParam('filters');
        if (filters) {
          return JSON.parse(decodeURIComponent(filters));
        }
        return [];
      },
      sendNarrowUpdate(narrow) {
        emitter.emit('fs-update-filter', narrow);
      },
      updateNarrow(filter, value) {
        let currentFilters = this.getCurrentFilters();
        let currentFiltersMinusPrice = currentFilters.filter(filter => filter[0] !== 'Price_from_to');
        currentFiltersMinusPrice.push([filter, value]);
        this.setUrlParam('filters', currentFiltersMinusPrice);
        this.sendNarrowUpdate(currentFiltersMinusPrice);
      },
      setUrlParam(paramName, paramValue) {
        const url = new URL(window.location.href);
        url.searchParams.set(paramName, JSON.stringify(paramValue));
        window.history.replaceState(null, null, url);
      },
      priceSliderFilter() {
        //update min
        this.currentMin = document.getElementById('slider-1').value;
        if (parseInt(this.currentMax) - parseInt(this.currentMin) <= this.minGap) {
          this.currentMin = parseInt(this.currentMax) - this.minGap;
        }
        //update max
        this.currentMax = document.getElementById('slider-2').value;
        if (parseInt(this.currentMax) - parseInt(this.currentMin) <= this.minGap) {
          this.currentMax = parseInt(this.currentMin) + this.minGap;
        }
        //fill color
        this.fillColor();
        if (this.timeout) {
          clearTimeout(this.timeout);
        }
        //let url = new URL(window.location.href);
        this.timeout = setTimeout(() => {
          this.updateNarrow('Price_from_to', this.currentMin + '-' + this.currentMax);
          this.timeout = null;
        }, 1000);
      },
      fillColor() {
        // Use cached element or query once
        if (!this.sliderTrackElement) {
          this.sliderTrackElement = document.getElementById('slider-track');
        }

        if (!this.sliderTrackElement) return;

        // Check if we have valid price range values
        if (!this.priceFilterMin || !this.priceFilterMax || this.priceFilterMin >= this.priceFilterMax) {
          // If no valid range, show full width
          this.sliderTrackElement.style.background = `linear-gradient(to right, #00000000 0%, ${this.sliderColor} 0%, ${this.sliderColor} 100%, #00000000 100%)`;
          return;
        }

        const possibleRange = this.priceFilterMax - this.priceFilterMin;
        const minSlideDistance = this.currentMin - this.priceFilterMin;
        const maxSlideDistance = this.currentMax - this.priceFilterMin;
        const percent1 = (minSlideDistance / possibleRange) * 100;
        const percent2 = (maxSlideDistance / possibleRange) * 100;

        this.sliderTrackElement.style.background = `linear-gradient(
      to right, 
      #00000000 ${percent1}% , 
      ${this.sliderColor} ${percent1}% , 
      ${this.sliderColor} ${percent2}%, 
      #00000000 ${percent2}%)`;
      },
      checkForURLParams() {
        const filters = this.getUrlParam('filters');
        if (filters) {
          const parsedFilters = JSON.parse(decodeURIComponent(filters));
          const priceFilter = parsedFilters.find(filter => filter[0] === 'Price_from_to');

          if (priceFilter) {
            const [min, max] = priceFilter[1].split('-');
            this.currentMin = min;
            this.currentMax = max;
            this.fillColor();
          } else {
            // No price filter found, reset to full range
            this.resetToFullRange();
          }
        } else {
          // No filters at all, reset to full range
          this.resetToFullRange();
        }
      },
      resetToFullRange() {
        this.currentMin = this.priceFilterMin;
        this.currentMax = this.priceFilterMax;
        this.fillColor();
      }
    },
    watch: {
      priceFilterMin(newVal, oldVal) {
        if (newVal !== oldVal && newVal) {
          this.currentMin = newVal;
          this.$nextTick(() => {
            this.fillColor();
          });
        }
      },
      priceFilterMax(newVal, oldVal) {
        if (newVal !== oldVal && newVal) {
          this.currentMax = newVal;
          this.$nextTick(() => {
            this.fillColor();
          });
        }
      }
    },
    mounted() {
      // Set up the monkey patch for history.replaceState to dispatch 'replacestate' events
      augmentHistoryReplaceState();

      // Initialize slider to full width first to prevent flash
      this.$nextTick(() => {
        this.sliderTrackElement = document.getElementById('slider-track');
        if (this.sliderTrackElement) {
          this.sliderTrackElement.style.background = `linear-gradient(to right, #00000000 0%, ${this.sliderColor} 0%, ${this.sliderColor} 100%, #00000000 100%)`;
        }
      });

      emitter.on('fs-update', e => {
        this.currentMin = e.facets?.find(filter => filter[0] === 'Price_min')?.[1][0];
        this.currentMax = e.facets?.find(filter => filter[0] === 'Price_max')?.[1][0];
        this.checkForURLParams();
        setTimeout(() => {
          this.fillColor();
          this.isInitialized = true;
        }, 500);
      });

      // Listen for filter clearing events
      emitter.on('filters-cleared', () => {
        this.resetToFullRange();
      });

      // Check URL params first
      this.checkForURLParams();

      // If no URL params set the slider values, use the full range
      if (!this.isInitialized) {
        this.currentMin = this.priceFilterMin;
        this.currentMax = this.priceFilterMax;
      }

      // Fill color after a short delay to ensure DOM is ready
      setTimeout(() => {
        this.fillColor();
        this.isInitialized = true;
      }, 100);
    },
    beforeUnmount() {
      emitter.off('fs-update');
      emitter.off('filters-cleared');
      // Clear cached DOM reference
      this.sliderTrackElement = null;
      if (this.timeout) clearTimeout(this.timeout);
      if (this.textInputTimeout) clearTimeout(this.textInputTimeout);
    }
  };
</script>
<template>
  <div class="container" :style="{ '--slider-color': sliderColor, '--border-color': borderColor }">
    <div class="slider-track" id="slider-track"></div>
    <hr class="slider-track-border" :style="{ borderColor: borderColor }" />

    <input type="range" :min="priceFilterMin" :max="priceFilterMax" :value="currentMin" :style="{ '--border-radius': borderRadius + '%' }" id="slider-1" class="price-range" @input="priceSliderFilter" />
    <input type="range" :min="priceFilterMin" :max="priceFilterMax" :value="currentMax" :style="{ '--border-radius': borderRadius + '%' }" id="slider-2" class="price-range" @input="priceSliderFilter" />
  </div>
  <div class="values" :style="{ '--slider-color': sliderColor, '--border-color': borderColor }">
    <div class="input-wrapper">
      <span class="currency-symbol first-currency">$</span>
      <input type="number" :value="currentMin" class="price-range" id="minInput" @input="userInputText($event)" />
      <span class="CAD" v-if="countryCode === 'CA'">CAD</span>
    </div>
    <div class="input-wrapper">
      <span class="currency-symbol second-currency">$</span>
      <input type="number" :value="currentMax" class="price-range" id="maxInput" @input="userInputText($event)" />
      <span class="CAD" v-if="countryCode === 'CA'">CAD</span>
    </div>
  </div>
</template>

<style scoped>
  .container {
    position: relative;
    width: 100%;
    min-height: 50px;
  }
  input[type='range'] {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    width: 100%;
    outline: none;
    position: absolute;
    margin: auto;
    top: 0;
    bottom: 0;
    background-color: transparent;
    pointer-events: none;
    z-index: 2;
  }
  .slider-track {
    width: 90%;
    height: 4px;
    position: absolute;
    margin: auto;
    top: 0;
    bottom: 0;
    z-index: 2;
    /* Default to full width to prevent flash */
    background: linear-gradient(to right, #00000000 0%, var(--slider-color) 0%, var(--slider-color) 100%, #00000000 100%);
    left: 10px;
  }

  input[type='range'] {
    padding-left: 0;
    padding-right: 8px;
  }

  input[type='range']::-webkit-slider-runnable-track {
    -webkit-appearance: none;
    height: 3px;
  }

  input[type='range']::-moz-range-track {
    -moz-appearance: none;
    height: 3px;
  }

  input[type='range']::-ms-track {
    appearance: none;
    height: 3px;
  }

  input[type='range']::-webkit-slider-thumb {
    -webkit-appearance: none;
    height: 12px;
    width: 12px;
    background-color: var(--slider-color);
    cursor: pointer;
    margin-top: -5px;
    pointer-events: auto;
    z-index: 2;
    border-radius: var(--border-radius);
  }

  input[type='range']::-moz-range-thumb {
    appearance: none;
    height: 12px;
    width: 12px;
    background-color: var(--slider-color);
    cursor: pointer;
    margin-top: -5px;
    pointer-events: auto;
    z-index: 2;
    border-radius: var(--border-radius);
  }

  input[type='range']::-ms-thumb {
    appearance: none;
    height: 12px;
    width: 12px;
    background-color: var(--slider-color);
    cursor: pointer;
    margin-top: -5px;
    pointer-events: auto;
    z-index: 2;
    border-radius: var(--border-radius);
  }

  input[type='range']:active::-webkit-slider-thumb {
    background-color: var(--slider-color);
    border: 1px solid var(--slider-color);
    z-index: 2;
    border-radius: var(--border-radius);
  }
  input[type='number'].price-range {
    padding-left: 0.25em;
    padding-right: 0;
    border: unset;
    margin: unset;
    border-radius: 0;
    z-index: 2;
    max-width: 30px;
    width: 3em;
  }
  .slider-track-border {
    margin: auto;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: -15px;
    width: 250px;
    height: 2px;
    z-index: 1;
  }
  .values {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .input-wrapper {
    width: 30%;
    padding: 0 1em;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid var(--border-color);
    margin-right: 8px;
  }

  .currency-symbol,
  .CAD,
  .price-range {
    color: var(--text);
    font-family: var(--GT-P);
    font-size: var(--GT-P-FONT-SIZE-DESK);
    line-height: var(--GT-P-LINE-HEIGHT-DESK);
  }
</style>
